/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./api";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const findBatchesByMonth = /* GraphQL */ `query FindBatchesByMonth($month: Int, $year: Int) {
  findBatchesByMonth(month: $month, year: $year) {
    day_bucket_date
    status
    user_id
    number_of_transactions
    updated_at
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FindBatchesByMonthQueryVariables,
  APITypes.FindBatchesByMonthQuery
>;
export const findBatchJobsByMonth = /* GraphQL */ `query FindBatchJobsByMonth($month: Int, $year: Int) {
  findBatchJobsByMonth(month: $month, year: $year) {
    day_bucket_date
    status
    user_id
    updated_at
    selectable
    totalEntries
    releasedEntries
    enrichedEntries
    enrichingEntries
    exceptionCount
    released_by
    released_at
    total_products
    products_in_gagis
    products_in_filing_pack
    refresh_timestamp
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FindBatchJobsByMonthQueryVariables,
  APITypes.FindBatchJobsByMonthQuery
>;
export const findBatchesWithStatusesInLastMonths = /* GraphQL */ `query FindBatchesWithStatusesInLastMonths(
  $statuses: [String]
  $offsetInHours: Int
) {
  findBatchesWithStatusesInLastMonths(
    statuses: $statuses
    offsetInHours: $offsetInHours
  ) {
    day_bucket_date
    status
    user_id
    number_of_transactions
    updated_at
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FindBatchesWithStatusesInLastMonthsQueryVariables,
  APITypes.FindBatchesWithStatusesInLastMonthsQuery
>;
export const findMissingAsyncResponses = /* GraphQL */ `query FindMissingAsyncResponses {
  findMissingAsyncResponses {
    entry_id
    enrichment_event
    job_id
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FindMissingAsyncResponsesQueryVariables,
  APITypes.FindMissingAsyncResponsesQuery
>;
export const findBatchesWithIssues = /* GraphQL */ `query FindBatchesWithIssues {
  findBatchesWithIssues {
    id
    created_at
    msg
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FindBatchesWithIssuesQueryVariables,
  APITypes.FindBatchesWithIssuesQuery
>;
export const findLocalClearanceDeadQMessages = /* GraphQL */ `query FindLocalClearanceDeadQMessages($originQueueName: String) {
  findLocalClearanceDeadQMessages(originQueueName: $originQueueName) {
    items {
      uuid
      originQueueName
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FindLocalClearanceDeadQMessagesQueryVariables,
  APITypes.FindLocalClearanceDeadQMessagesQuery
>;
export const listFilingPackStatuses = /* GraphQL */ `query ListFilingPackStatuses {
  listFilingPackStatuses
}
` as GeneratedQuery<
  APITypes.ListFilingPackStatusesQueryVariables,
  APITypes.ListFilingPackStatusesQuery
>;
export const listFilingPacks = /* GraphQL */ `query ListFilingPacks($filter: FilingPackFilter) {
  listFilingPacks(filter: $filter) {
    items {
      id
      period_id
      reference
      mrn
      lrn
      status
      error_message
      created
      submitted
      released
      created_at
      updated_at
      __typename
    }
    totalCount
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFilingPacksQueryVariables,
  APITypes.ListFilingPacksQuery
>;
export const filingPack = /* GraphQL */ `query FilingPack($filingPackId: String!) {
  filingPack(filingPackId: $filingPackId) {
    id
    period_id
    reference
    mrn
    lrn
    status
    error_message
    created
    submitted
    released
    created_at
    updated_at
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FilingPackQueryVariables,
  APITypes.FilingPackQuery
>;
export const listDeclarationPeriodStatuses = /* GraphQL */ `query ListDeclarationPeriodStatuses {
  listDeclarationPeriodStatuses
}
` as GeneratedQuery<
  APITypes.ListDeclarationPeriodStatusesQueryVariables,
  APITypes.ListDeclarationPeriodStatusesQuery
>;
export const listDeclarationPeriods = /* GraphQL */ `query ListDeclarationPeriods($filter: DeclarationPeriodFilter) {
  listDeclarationPeriods(filter: $filter) {
    items {
      id
      declarationPeriod
      filingPacksCreated
      filingPacksAccepted
      filingPacksReleased
      status
      __typename
    }
    totalCount
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDeclarationPeriodsQueryVariables,
  APITypes.ListDeclarationPeriodsQuery
>;
export const getPayloadUrlOnly = /* GraphQL */ `query GetPayloadUrlOnly(
  $region: String!
  $bucket: String!
  $key: String!
  $version: String
) {
  getPayloadUrlOnly(
    region: $region
    bucket: $bucket
    key: $key
    version: $version
  ) {
    contentType
    preSignedUrl
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPayloadUrlOnlyQueryVariables,
  APITypes.GetPayloadUrlOnlyQuery
>;
export const listDeclarationPeriodEvents = /* GraphQL */ `query ListDeclarationPeriodEvents($filter: DeclarationPeriodEventFilter) {
  listDeclarationPeriodEvents(filter: $filter) {
    id
    eventTime
    declarationId
    flowStep
    status
    errorMessage
    lrn
    mrn
    s3Reference
    payloadSize
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDeclarationPeriodEventsQueryVariables,
  APITypes.ListDeclarationPeriodEventsQuery
>;
export const findSystemEventsByFilingPackId = /* GraphQL */ `query FindSystemEventsByFilingPackId($filingPackId: String!) {
  findSystemEventsByFilingPackId(filingPackId: $filingPackId) {
    id
    declaration_id
    type
    event_id
    event_type
    event_timestamp
    flow_step
    status
    error_message
    s3_reference
    payload_size
    created_at
    updated_at
    filing_pack_id
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FindSystemEventsByFilingPackIdQueryVariables,
  APITypes.FindSystemEventsByFilingPackIdQuery
>;
